import React from 'react';
import { Radio, Modal,message,Button } from 'antd';
// import $ from '../../../common/AjaxRequest';
// import API_URL from '../../../common/url';
const RadioGroup = Radio.Group;
class ConterctRelateSite extends React.Component {
    state = {
        selectValue:null,
    }    
    hide = ()=>{
        this.setState({selectValue:null})
        this.props.hideCenterctRelateSite();
    }
    onOK = ()=>{
        const { centerRelateParams:{noticeId,readStatus} } = this.props;
        const { selectValue } = this.state;
        if(!selectValue){
            message.warning('未选择选项');
        }else if(selectValue == 'HOLDON'){
            this.hide()
        }else if(readStatus == 'unreaded'){
            this.props.confirmNoticeReadByOne(noticeId)
            location.href = '/#/site/detail';
            message.success('处理成功');
        }else{
            location.href = '/#/site/detail';
        }
    }

    render() {
        const { centerRelateParams:{visible} } = this.props;
        const { selectValue } = this.state;
        return (
            <Modal
                    title="中心与合同关联提醒"
                    visible={visible}
                    onCancel={this.hide}
                    className="preview-modal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width="400px"
                    footer={<Button type="primary" onClick={()=>{this.onOK()}}>确定</Button>}
                >
                    <div style={{ padding: '30px 40px' }}>
                        <h5 style={{ padding: '10px 0', fontSize: 10 }}>是否现在就去关联中心</h5>
                        <RadioGroup style={{ paddingLeft: '20px' }} onChange={(e)=>{this.setState({selectValue:e.target.value})}} value={selectValue}>
                            <Radio value={'LETSGO'}>是，现在就去关联中心</Radio><br />
                            <Radio value={'HOLDON'}>否，请稍后提醒我去关联中心</Radio>
                        </RadioGroup>
                    </div>
                </Modal>

        );
    }
}

export default ConterctRelateSite;



// WEBPACK FOOTER //
// ./src/components/layout/notice/ConterctRelateSite.js